import { render, staticRenderFns } from "./ReadTextField.vue?vue&type=template&id=39869a5b&"
import script from "./ReadTextField.vue?vue&type=script&lang=js&"
export * from "./ReadTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39869a5b')) {
      api.createRecord('39869a5b', component.options)
    } else {
      api.reload('39869a5b', component.options)
    }
    module.hot.accept("./ReadTextField.vue?vue&type=template&id=39869a5b&", function () {
      api.rerender('39869a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/formatted/ReadTextField.vue"
export default component.exports